interface VisitedPage {
  name: string;
  url: string;
  count?: number;
}

const MAX_RECENTS_ITEMS = 10;
const MAX_FREQUENTS_ITEMS = 5;

// Key for storing the full tracking data
const FREQUENT_PAGES_TRACKING = 'frequentPagesTracking';
// Key for storing the truncated display version
const FREQUENT_PAGES_DISPLAY = 'frequentPages';

export const trackPageVisit = (name: string, url: string) => {
  // Handle Recent Pages (FIFO)
  const recentPages = JSON.parse(localStorage.getItem('recentPages') || '[]') as VisitedPage[];
  const newRecentPages = [
    { name, url },
    ...recentPages.filter(page => page.url !== url)  // Remove duplicates
  ].slice(0, MAX_RECENTS_ITEMS);
  localStorage.setItem('recentPages', JSON.stringify(newRecentPages));

  // Handle Frequent Pages - using full tracking array
  const frequentPagesTracking = JSON.parse(localStorage.getItem(FREQUENT_PAGES_TRACKING) || '[]') as VisitedPage[];
  const existingFreqPage = frequentPagesTracking.find(page => page.url === url);
  
  let newFrequentPagesTracking: VisitedPage[];
  if (existingFreqPage) {
    // Increment count for existing page
    newFrequentPagesTracking = frequentPagesTracking
      .map(page => page.url === url ? { ...page, count: (page.count || 0) + 1 } : page)
      .sort((a, b) => (b.count || 0) - (a.count || 0));
  } else {
    // Add new page with count 1
    newFrequentPagesTracking = [
      ...frequentPagesTracking,
      { name, url, count: 1 }
    ].sort((a, b) => (b.count || 0) - (a.count || 0));
  }
  
  // Store the full tracking data
  localStorage.setItem(FREQUENT_PAGES_TRACKING, JSON.stringify(newFrequentPagesTracking));
  
  // Create and store the truncated display version
  const displayVersion = newFrequentPagesTracking.slice(0, MAX_FREQUENTS_ITEMS);
  localStorage.setItem(FREQUENT_PAGES_DISPLAY, JSON.stringify(displayVersion));
}; 